import { jsxs, jsx, Fragment } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { TooltipTitleTypographyContainer } from "../styles/title-typography-container.es.js";
import { TooltipDescriptionTypographyContainer } from "../styles/description-typography-container.es.js";
function TooltipContainerText({
  title,
  description
}) {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    title && /* @__PURE__ */ jsx(TooltipTitleTypographyContainer, { className: "tooltip-title", variant: "subtitle2", children: title }),
    /* @__PURE__ */ jsx(TooltipDescriptionTypographyContainer, { className: "tooltip-description", variant: "caption", children: description })
  ] });
}
export {
  TooltipContainerText
};
//# sourceMappingURL=tooltip-container.es.js.map
